module.exports = __webpack_public_path__ + "img/34.6ccc0eab.png";